import React, { useEffect } from "react";
import { TextField } from "../../../ui/FormElement";

import { useFormikContext } from "formik";

const MonthlyDiscountName = (props) => {
  const { isDisabled, ...rest } = props;

  const {
    values: { monthly_discount_enable },
    setFieldValue,
  } = useFormikContext();

  return (
    <>
      <TextField
        disabled={!monthly_discount_enable || isDisabled}
        name="monthly_discount_name"
        {...rest}
      />
    </>
  );
};

export default MonthlyDiscountName;
